import { FC, useContext, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar, lastAccessedOrganizationVar } from '../../cache';
import { context as HistoryContext } from '../context/history';
import { context as ConfigContext } from '../context/config';
import Page from '../page/IframePage';
import { IframePage } from '../../entity/types';

type Props = {
  className?: string;
};
type Params = {
  profileId?: string;
};

const IframePage: FC<Props> = ({ className }) => {
  const { id: user } = useReactiveVar(currentUserVar) ?? { id: '' };
  const { id: org } = useReactiveVar(lastAccessedOrganizationVar) ?? { id: '' };
  const history = useContext(HistoryContext);

  const { profileId } = useParams<Params>();
  const { pathname, search } = useLocation();

  const config = useContext(ConfigContext);

  const [url, shouldAdjustStyle] = useMemo(() => {
    const queryParse = new URLSearchParams(search);
    queryParse.set('header', 'none');
    queryParse.delete('org');
    if (pathname === '/engine/site-analytics') return [config.SITE_ANALYTICS + 'organizations/' + org + '/', false];
    if (pathname === '/engine/exp-portfolio') return [config.EXP_PORTFOLIO + 'organizations/' + org + '/', false];
    if (pathname === '/engine/roundreport') return [config.ROUND_REPORT + 'organizations/' + org + '/', false];
    if (pathname === '/engine/sitedock')
      return [config.SITE_DOCK + '?org=' + org + '#/organizations/' + org + '/', false];
    if (pathname === '/engine/my_experiments')
      return [config.K2_BASE_URL + '/my_experiments/' + '?' + queryParse.toString(), true];
    if (pathname.match(/\/engine\/experiments\/[0-9]+/))
      return [config.K2_BASE_URL + pathname.split('/engine').join('') + '?' + queryParse.toString(), true];
    if (pathname.match(/\/engine\/goals\/[0-9]+\/edit/))
      return [config.K2_BASE_URL + pathname.split('/engine').join('') + '?' + queryParse.toString(), true];
    if (pathname.match(/\/engine\/users\/[0-9]+\/experiments/))
      return [config.K2_BASE_URL + '/users/' + org + '/experiments' + '?' + queryParse.toString(), true];
    if (pathname.match(/\/engine\/organizations\/[0-9]+\/goals/))
      return [config.K2_BASE_URL + '/organizations/' + org + '/goals' + '?' + queryParse.toString(), true];
    // if (pathname.match(/\/engine\/organizations\/[0-9]+\/settings/))
    //   return [config.K2_BASE_URL + '/organizations/' + org + '/settings' + '?' + queryParse.toString(), true];
    if (pathname === '/engine/experiments')
      return [config.K2_BASE_URL + '/users/' + org + '/experiments' + '?' + queryParse.toString(), true];
    if (pathname === '/growth-hacker/me')
      return [config.K2_BASE_URL + `/users/${user}?tab=creative&${queryParse.toString()}`, true];
    if (pathname.match(/\/growth-hacker\/[0-9]+/))
      return [config.K2_BASE_URL + `/users/${profileId}?tab=creative&${queryParse.toString()}`, true];
    return ['', false];
  }, [pathname, search, org, user]);

  return url ? (
    <Page
      url={url}
      key={history.location.key}
      id="iframe"
      marginTop={shouldAdjustStyle ? '-60px' : '-58px'}
      marginLeft={'0px'}
      className={className}
    />
  ) : null;
};

export default IframePage;
